import { inject } from '@angular/core';
import { CanActivateFn, Router } from "@angular/router";
import { of } from "rxjs";
import { LocalStorageService } from "../providers/local-storage/local-storage.service";

export const authGuard: CanActivateFn = (_route, state) => {
  const localStorage = inject(LocalStorageService);
  const router = inject(Router);

    if (localStorage.getToken() !== "") {
      return of(true);
    } else {
      router.navigateByUrl("/login", {
        state: { url: state.url },
      });
      return of(false);
    }
};